import React, { useEffect, useState, useRef } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Florencia', 'Lucía', 'Sofía', 'Martina', 'Camila', 'Valentina', 'Paula', 'Julieta', 'Antonella', 'Carolina', 'Marcela', 'Gabriela', 'Soledad'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Santa Fe', 'Tucumán', 'Neuquén', 'Salta', 'Bahía Blanca', 'San Juan'];
const TIMES = ['hace 5 minutos', 'hace 12 minutos', 'hace 23 minutos', 'hace 1 hora', 'hace 2 horas'];
const pick = <T,>(arr: T[]) => arr[Math.floor(Math.random() * arr.length)];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setPurchaseData({
        name: pick(NAMES),
        city: pick(CITIES),
        time: pick(TIMES)
      });
      setIsVisible(true);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      hideTimerRef.current = setTimeout(() => setIsVisible(false), 5000);
    };
    // First popup after 8 seconds
    const initialTimer = setTimeout(showPopup, 8000);
    // Then every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 right-4 md:right-auto z-50 animate-fade-in-up" data-id="element-284">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 pr-10 flex items-start max-w-sm relative" data-id="element-285">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-286">
          <X className="w-4 h-4" data-id="element-287" />
        </button>

        <div className="bg-green-100 rounded-full p-2 mr-3 flex-shrink-0" data-id="element-288">
          <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-289" />
        </div>

        <div data-id="element-290">
          <p className="text-sm text-gray-800" data-id="element-291">
            <span className="font-bold" data-id="element-292">{purchaseData.name}</span> de{' '}
            <span className="font-bold" data-id="element-293">{purchaseData.city}</span>
          </p>
          <p className="text-sm text-gray-600" data-id="element-294">compró el Megapack Élite</p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-295">{purchaseData.time}</p>
        </div>
      </div>
    </div>;
}